const inFlight = new Map<string, Promise<unknown>>();

export function runInFlight<T>(key: string, task: () => Promise<T>): Promise<T> {
  const existing = inFlight.get(key);
  if (existing) {
    return existing as Promise<T>;
  }

  const promise = task().finally(() => {
    if (inFlight.get(key) === promise) {
      inFlight.delete(key);
    }
  });

  inFlight.set(key, promise);
  return promise;
}

export function clearInFlight(key: string): void {
  inFlight.delete(key);
}
